const { BODY_ELEMENTS, BODY_EVENTS, LIST_NAMES } = require('./analyticsConst');
const analyticUtils = require('./analyticUtils');
const { getOriginalPID } = require('../common/utils/doubleLookUtils');
const {
  addDocumentDelegatedListener,
  onOnce,
} = require('../common/utils/domEvents');
const { analyticsEventBus, ANALYTICS_EVENTS } = require('./events');
const { default: getFrontConfig } = require('../common/getFrontConfig');
const { getPidFromQueryString } = require('../common/utils/queryString');
const { cartItemListStorage } = require('./stores/itemList');
const {
  findProductInCart,
  getCartFromLocalStorage,
} = require('../cart/localCart');
const {
  buildItemListAndPositionForJustAddedToCartProduct,
} = require('./helpers/itemListAndPositionHelpers');

const FRONT_CONFIG = getFrontConfig();
/**
 * @enum {string}
 */
const BaseProductTileContext = FRONT_CONFIG.vue.BaseProductTile.context;

/* -------------------------------------------------------------------------- *\
 * CART                                                                       *
\* -------------------------------------------------------------------------- */
// Add to cart
// Listen to product:beforeAddTocart event to get pid and add to cart context
$('body').on(BODY_EVENTS.addToCart, (event, data) => {
  if (!data) return;
  // In Shop the look and Fit Analytics, data is a plain object with event data
  let addToCartPlace = data.addToCartPlace || gaInfo.pageType; // Provided by event or default
  let { pid } = data;

  const currentTarget = data instanceof jQuery ? data[0] : data;
  if (currentTarget instanceof HTMLElement) {
    // Get event target context to get pid
    const container = currentTarget.closest('.product-detail');
    if (container) {
      pid = container.classList.contains('product-detail-vue')
        ? container.querySelector('.product-id').innerText
        : container.dataset.productId;
    }

    // Special cases for Save for later, Wishlist and Search, as they are not pageType (modal behaviour)
    if (currentTarget.closest('.save-for-later-container')) {
      addToCartPlace = LIST_NAMES['save-for-later'];
    } else if (currentTarget.closest('.wishlist-container')) {
      addToCartPlace = LIST_NAMES.wishlist;
    } else if (currentTarget.closest('.the-search__results')) {
      addToCartPlace = LIST_NAMES.search;
    }
  }

  if (pid) {
    analyticUtils.handleDimensionsData(getOriginalPID(pid), addToCartPlace);
  }
});

$('body').on(
  BODY_EVENTS.addedToCart,
  /**
   * Event handler triggered when a product is added to cart.
   *
   * @param {JQuery.TriggeredEvent} event - The jQuery event object.
   * @param {Object} data - Payload with details about cart and product.
   * @param {boolean} [data.error] - True if error occurred adding to cart.
   * @param {Object} data.product - The product object added to the cart.
   * @param {Object} data.cart - The current shopping cart object.
   * @param {string} [data.doubleLookPID] - Product ID of the double look used
   *  to add this product to the cart
   * @param {string} data.pliUUID - UUID of the product line item.
   * @param {BaseProductTileContext} data.tileContext - UI context origin.
   * @param {string} data.tilePosition - Product position in list.
   */
  (event, data) => {
    if (data.error || !data.product) return;

    const { cart, doubleLookPID, product, tileContext, tilePosition } = data;

    const addedToCartContexts =
      ANALYTICS_EVENTS.PAYLOADS.productAddedToCart.context;

    /**
     * @type {string}
     * Place where the product was added to cart.
     * 'product' if from PDP, else from PLP or minicart.
     */
    let addedToCartContext;
    if (tileContext === BaseProductTileContext.plpGrid) {
      addedToCartContext = addedToCartContexts.category;
    } else if (tileContext === BaseProductTileContext.search) {
      addedToCartContext = addedToCartContexts.search;
    } else if (tileContext === BaseProductTileContext.crossSellingGrid) {
      addedToCartContext = addedToCartContexts.crossSellingGrid;
    } else if (
      [
        BaseProductTileContext.minicartSlider,
        BaseProductTileContext.minicartSliderEmptyCart,
      ].includes(tileContext)
    ) {
      addedToCartContext = addedToCartContexts.cart;
    } else if (tileContext === BaseProductTileContext.homeShopTheLook) {
      addedToCartContext = addedToCartContexts.shopTheLook;
    } else {
      addedToCartContext = addedToCartContexts.product;
    }

    const itemListAndPosition =
      buildItemListAndPositionForJustAddedToCartProduct({
        productId: product.id,
        tileContext,
        tilePosition: parseInt(tilePosition, 10),
      });

    const productLineItem = cart.items.find((pli) => pli.UUID === data.pliUUID);

    analyticsEventBus.publish(ANALYTICS_EVENTS.productAddedToCart, {
      cart,
      context: addedToCartContext,
      doubleLookPID,
      list: itemListAndPosition.list,
      position: itemListAndPosition.position,
      product,
      productLineItem,
    });

    analyticUtils.updateCartGaInfo(data.cart);
  }
);

// Remove from cart
$('body').on(BODY_EVENTS.removeFromCart, (event, data) => {
  if (data.error) return;

  // publish
  const product = findProductInCart(data.pid);
  analyticsEventBus.publish(analyticsEventBus.EVENTS.productRemovedFromCart, {
    cart: data.basket,
    product,
  });

  analyticUtils.updateCartGaInfo(data.basket);
});

// Update quantity
$('body').on(BODY_EVENTS.updateQuantity, (event, data) => {
  if (data.error) return;
  const cartFromLocalStorage = getCartFromLocalStorage();
  if (cartFromLocalStorage) {
    const pid = getPidFromQueryString(data.queryString);
    const productFromLocalStorage = findProductInCart(
      pid,
      cartFromLocalStorage
    );
    const updatedProduct = {
      ...findProductInCart(pid, data),
      doubleLookPID: productFromLocalStorage?.doubleLookPID,
    };

    if (updatedProduct.quantity < productFromLocalStorage?.quantity) {
      analyticsEventBus.publish(ANALYTICS_EVENTS.productRemovedFromCart, {
        product: updatedProduct,
      });
    } else {
      const { list, position } = cartItemListStorage.getItem(pid);
      const productLineItem = data.items.find((pli) => pli.id === pid);
      analyticsEventBus.publish(ANALYTICS_EVENTS.productAddedToCart, {
        context: ANALYTICS_EVENTS.PAYLOADS.productAddedToCart.context.cart,
        list,
        position,
        product: updatedProduct,
        productLineItem,
      });
    }

    if (pid) {
      analyticUtils.handleDimensionsData(getOriginalPID(pid), LIST_NAMES.cart);
    }
  }
});

/**
 * Publish Cart landing page is viewed GA4 event when empty.
 * 1st step of checkout funnel
 */
function sendEmptyCart() {
  analyticsEventBus.publish(ANALYTICS_EVENTS.cartEmptyViewed);
}
document.addEventListener('analytics-emptyCart', sendEmptyCart);

/* -------------------------------------------------------------------------- *\
 * CHECKOUT                                                                   *
\* -------------------------------------------------------------------------- */
/**
 * Publish Cart landing page is viewed GA4 event.
 * 1st step of checkout funnel
 */
function sendCheckoutFirstStep() {
  analyticsEventBus.publish(ANALYTICS_EVENTS.checkoutCartViewed);
}
document.addEventListener('analytics-checkoutFirstStep', sendCheckoutFirstStep);

/* -------------------------------------------------------------------------- *\
 * LOGIN                                                                      *
\* -------------------------------------------------------------------------- */
// Forgot your password form is open when clicking in link on Login Page
$('body').on('click', BODY_ELEMENTS.forgotPassword, () => {
  analyticsEventBus.publish(ANALYTICS_EVENTS.loginForgotPasswordOpened);
});

/* -------------------------------------------------------------------------- *\
 * PDP                                                                        *
\* -------------------------------------------------------------------------- */
// Fit Analytics link click
$('body').on('click', BODY_ELEMENTS.pdpFitAnalyticsLink, () => {
  analyticsEventBus.publish(
    ANALYTICS_EVENTS.productDetailsItemClicked,
    ANALYTICS_EVENTS.PAYLOADS.productDetailsItemClicked.item.fitAnalytics
  );
});

/* -------------------------------------------------------------------------- *\
 * ATC NUMBER EVENTS                                                          *
\* -------------------------------------------------------------------------- */
const atcPhoneNumberSelector = '.contact-text__number,.phone';
$('body').on('click', atcPhoneNumberSelector, (event) => {
  let location;
  const isInsideMinicart = !!event.target.closest('.minicart-popup');
  if (isInsideMinicart) {
    location = ANALYTICS_EVENTS.PAYLOADS.atcPhoneClicked.location.minicart;
  } else {
    const page = document.querySelector('.page');
    if (page?.classList.contains('page--checkout')) {
      location = ANALYTICS_EVENTS.PAYLOADS.atcPhoneClicked.location.checkout;
    } else if (page?.classList.contains('page--cart')) {
      location = ANALYTICS_EVENTS.PAYLOADS.atcPhoneClicked.location.cart;
    }
  }
  if (location) {
    analyticsEventBus.publish(ANALYTICS_EVENTS.atcPhoneClicked, location);
  }
});

/* -------------------------------------------------------------------------- *\
 * CHAT EVENT                                                                 *
\* -------------------------------------------------------------------------- */
/**
 * Publish Chat is opened GA4 event
 */
function handleChatOpened() {
  analyticsEventBus.publish(ANALYTICS_EVENTS.chatOpened);
}
document.addEventListener('chat:opened', handleChatOpened);

/* -------------------------------------------------------------------------- *\
 * FAQ EVENTS                                                                 *
\* -------------------------------------------------------------------------- */
addDocumentDelegatedListener('click', BODY_ELEMENTS.clickFaqSection, (e) => {
  analyticsEventBus.publish(ANALYTICS_EVENTS.faqsItemclicked, {
    item: e.target.dataset.section,
    option: e.target.href.split('q=')?.pop(),
  });
});

/* -------------------------------------------------------------------------- *\
 * VIRTUAL TRY-ON EVENTS                                                      *
\* -------------------------------------------------------------------------- */
/**
 * Publish Virtual Try On product is clicked GA4 event
 */
function handleVirtualTryOnClicked() {
  analyticsEventBus.publish(ANALYTICS_EVENTS.virtualTryOnClicked);
}
document.addEventListener('virtualTryOn:clicked', handleVirtualTryOnClicked);

/* -------------------------------------------------------------------------- *\
 * WISHLIST EVENTS                                                            *
\* -------------------------------------------------------------------------- */
addDocumentDelegatedListener('click', BODY_ELEMENTS.wishlistLogin, () => {
  analyticsEventBus.publish(ANALYTICS_EVENTS.wishlistLoginLinkClicked);
});

/* -------------------------------------------------------------------------- *\
 * MODALS EVENTS                                                              *
\* -------------------------------------------------------------------------- */
/**
 * Publish confirm address in Vertex is clicked GA4 event.
 * Location: suggesting address modal in checkout.
 */
function confirmAddressVertexModal() {
  analyticsEventBus.publish(
    analyticsEventBus.EVENTS.modalVertexSuggestedAddressConfirmed
  );
}
document.addEventListener(
  'suggestedAddressSelected',
  confirmAddressVertexModal
);

/* -------------------------------------------------------------------------- *\
 * EQUALWEB (ACCESSIBILITY) EVENTS                                            *
\* -------------------------------------------------------------------------- */
const toggleAccessibilityType = `${BODY_ELEMENTS.accessibilityOpenIcon}, ${BODY_ELEMENTS.accessibilityCloseIcon}`;
addDocumentDelegatedListener('click', toggleAccessibilityType, (event) => {
  const target = event?.target?.closest(toggleAccessibilityType);
  const clickAction = target.matches(BODY_ELEMENTS.accessibilityOpenIcon)
    ? ANALYTICS_EVENTS.PAYLOADS.accessibilityIconClicked.action.open
    : ANALYTICS_EVENTS.PAYLOADS.accessibilityIconClicked.action.close;

  analyticsEventBus.publish(ANALYTICS_EVENTS.accessibilityIconClicked, {
    action: clickAction,
    pageType: gaInfo.pageType,
  });
});

/* -------------------------------------------------------------------------- *\
 * BIRTHDAY LANDING EVENTS                                                    *
\* -------------------------------------------------------------------------- */
addDocumentDelegatedListener(
  'click',
  BODY_ELEMENTS.birthdayShortcutItem,
  (event) => {
    let item = event.target.dataset.id;
    if (!item) {
      item = event.target.parentNode.dataset.id;
    }
    if (item) {
      analyticsEventBus.publish(
        ANALYTICS_EVENTS.birthdayLandingItemClicked,
        item
      );
    }
  }
);

/* -------------------------------------------------------------------------- *\
 * TOP BANNER EVENTS                                                          *
\* -------------------------------------------------------------------------- */
/**
 * Publish top banner is clicked GA4 event
 */
function handleTopBannerClicked() {
  analyticsEventBus.publish(ANALYTICS_EVENTS.topBannerClicked, {
    item: gaInfo.pageUrl,
  });
}
document.addEventListener('topBanner:clicked', handleTopBannerClicked);

/**
 * It removes all the event listeners
 */
function removeEventListeners() {
  document.removeEventListener(
    'analytics-checkoutFirstStep',
    sendCheckoutFirstStep
  );
  document.removeEventListener('analytics-emptyCart', sendEmptyCart);
  document.removeEventListener('chat:opened', handleChatOpened);
  document.removeEventListener(
    'suggestedAddressSelected',
    confirmAddressVertexModal
  );
  document.removeEventListener(
    'virtualTryOn:clicked',
    handleVirtualTryOnClicked
  );
  document.removeEventListener('topBanner:clicked', handleTopBannerClicked);
}

onOnce(window, 'beforeunload', () => {
  removeEventListeners();
});
